import Viewer from './viewer';
import Graph from './interface';
import Remote from './remote';
import Utils from '../shared/utils';
import Paywall from '../shared/paywall';
import ContentManager from './content_manager';
import PurpleGuideRenderer from '../shared/reactLoader';
import { StartSessionPopupRenderer, LoopRemixPopupRenderer } from '../shared/reactLoader';

export default class PreviewMode extends Viewer {
  constructor(options) {
    super(options);

    this.graph = new Graph(document.getElementById('viewer'), {
      ungrabbable: true,
      userZoomingEnabled: true,
      userPanningEnabled: true,
      zoom: 0.6,
    });

    this.remote = new Remote('', {});

    $('.lp--js-editLoop').on(Utils.interactionEvent, (ev) => {
      if (this._current) {
        window.location.href = ev.target.getAttribute('href') + '#' + this._current.id();
        return false;
      }
    });
  }

  fetchGraphData() {
    return super.fetchGraphData();
  }

  build() {
    super.build();

    $('body').addClass('preview');

    $('.lp--js-openStartSessionModal').on(Utils.interactionEvent, (ev) => {
      ev.preventDefault();
      let start = () => {
        const userToken = window.viewer.options.userToken;
        StartSessionPopupRenderer.render(userToken, this.options);
      };
      this.options.circle_options & PreviewMode.Open
        ? start()
        : Paywall.requirePremium().then(() => {
            start();
          });

      PurpleGuideRenderer.render('startASession');
    });

    $('.lp--js-remixLoop').on(Utils.interactionEvent, (ev) => {
      ev.preventDefault();
      Paywall.requirePremium().then(() => {
        const { userToken, circle_id, circle_name } = this.options;
        LoopRemixPopupRenderer.render(userToken, circle_id, circle_name);
      });
    });
  }

  shouldDisplayCircleOnLoad() {
    return true;
  }

  markProgress() {
    //no-op
  }

  supportsCommunication() {
    return false;
  }

  requireSession() {
    return false;
  }

  inSession() {
    return false;
  }

  getGraphURL() {
    return 'learn/graph/' + this.options.circle_id + '/preview';
  }

  getURLFor(type, context, options) {
    switch (type) {
      case ContentManager.Content.Circle:
        if (this.options.shared_link) {
          return 'learn/preview/' + context.id + '/shared';
        } else {
          return 'learn/preview/' + context.id;
        }
      case ContentManager.Content.Node:
        return 'learn/preview/' + options.circle_id + '/node/' + context.getId() + '/content';
      case ContentManager.Content.Chunk:
        return options.circle_id + '/chunk/' + context.getId() + '/content';
      case ContentManager.Content.Task:
      case ContentManager.Content.Quiz:
      case ContentManager.Content.Blog:
      case ContentManager.Content.Legend:
      case ContentManager.Content.Correlation:
      case ContentManager.Content.Evaluation:
        return context.getId() + '/preview/';
      default:
        return super.getURLFor(type, context, options);
    }
  }
}

PreviewMode.Open = 1;
